/**
 * Service Class to interact with Browser Cookie Entity (currently used to hold device Id).
 *
 * @since APE-230
 */
class CookieService {
  /**
   * Method to get the device Id from cookie.
   *
   * @returns device id
   */
  public getDeviceId(): string {
    let deviceId: string | undefined = this.getCookieValue('deviceId');

    if (!deviceId) {
      deviceId = crypto.randomUUID();
      document.cookie = 'deviceId=' + deviceId;
    }
    return deviceId as string;
  }

  /**
   * Method to get cookie value.
   *
   * @param field cookie key
   * @returns cookie value
   */
  private getCookieValue(field: string): string | undefined {
    if (document.cookie) {
      const cookies: string[] = document.cookie.split(';');
      for (let i = 0; i < cookies?.length; i++) {
        const cookie = cookies[i];
        const cookieParts = cookie.split('=');
        if (cookieParts[0].trim() === field) {
          return cookieParts[1];
        }
      }
    }
  }
}

export { CookieService };
